import React, { useCallback, useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import SearchForm from "./components/SearchForm";
import ListTable from "./components/ListTable";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import {
  fetchListMonitor,
  fetchInquireNumberList,
  fetchAddPortabilityNumberList,
  fetchInquireNumberReportList,
  fetchPublishList,
} from "../../../store/SendMessageSlice";
import { useLocation, useNavigate } from "react-router-dom";
import SubmitForm from "../Manual/components/SubmitForm";
import { Tabs } from "antd";
import InquireListTable from "./components/InquireListTable";
import AddPortabilityNumberListTable from "./components/AddPortabilityNumberListTable";
import { CONSTANT } from "../../../config/Constant";
import PublishListTable from "./components/PublishListTable";

const Monitor: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [messageAction, setMessageAction] = useState<string | null>("");
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [inquireListData, setInquireListData] = useState<any[]>([]);
  const [publishListData, setPublishListData] = useState<any[]>([]);
  const [addProtNumberListData, setAddProtNumberList] = useState<any[]>([]);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });

  // const [dataViewDrawer, setDataViewDrawer] = useState<any>();
  // const [apiResponse, setApiResponse] = useState<any>();

  const getList = useCallback(
    (data?: any) => {
      setTableLoading(true);
      const payload = {
        ...data,
        current: data?.current ?? 1,
        page_size: data?.page_size ?? 10,
      };
      dispatch(fetchListMonitor(payload))
        .then((res: any) => {
          setListData(res?.data);
          setTotalData(res?.total_data);
          setTableLoading(false);
        })
        .catch(() => {
          setListData([]);
          // if (messageAction === 'Check') {
          //   setTotalData(0);
          // }
          setTableLoading(false);
        });
    },
    [dispatch]
  );

  const getInquireList = useCallback(
    (data?: any) => {
      setTableLoading(true);
      const payload = {
        ...data,
        current: data?.current ?? 1,
        page_size: data?.page_size ?? 10,
      };
      dispatch(fetchInquireNumberList(payload))
        .then((res: any) => {
          setInquireListData(res?.data?.data);
          // setListData(res?.data);
          setTotalData(res?.data?.total_data);
          setTableLoading(false);
        })
        .catch(() => {
          setInquireListData([]);
          // if (messageAction === 'Inquire_number') {
          //   setTotalData(0);
          // }
          setTableLoading(false);
        });
    },
    [dispatch]
  );

  const getInquireReportList = (data?: any) => {
    setTableLoading(true);
    const payload = {
      request_id: data,
    };
    dispatch(fetchInquireNumberReportList(payload))
      .then((res: any) => {
        const listPayload = {
          current: paginationData?.current ?? 1,
          page_size: paginationData?.page_size ?? 10,
        };
        getInquireList(listPayload);
        setTableLoading(false);
      })
      .catch(() => {
        setTableLoading(false);
      });
  };

  const getPublishList = useCallback(
    (data?: any) => {
      setTableLoading(true);
      const payload = {
        ...data,
        current: data?.current ?? 1,
        page_size: data?.page_size ?? 10,
      };
      dispatch(fetchPublishList(payload))
        .then((res: any) => {
          setPublishListData(res?.data?.data);
          // setListData(res?.data);
          setTotalData(res?.data?.total_data);
          setTableLoading(false);
        })
        .catch(() => {
          setPublishListData([]);
          // if (messageAction === 'Inquire_number') {
          //   setTotalData(0);
          // }
          setTableLoading(false);
        });
    },
    [dispatch]
  );

  const getPublishReportList = (data?: any) => {
    setTableLoading(true);
    const payload = {
      request_id: data,
    };
    dispatch(fetchInquireNumberReportList(payload))
      .then((res: any) => {
        const listPayload = {
          current: paginationData?.current ?? 1,
          page_size: paginationData?.page_size ?? 10,
        };
        getInquireList(listPayload);
        setTableLoading(false);
      })
      .catch(() => {
        setTableLoading(false);
      });
  };

  const getAddPortNumberList = useCallback(
    (data?: any) => {
      setTableLoading(true);

      const payload = {
        ...data,
        pageNumber: data?.pageNumber ?? 1,
        pageSize: data?.pageSize ?? 10,
      };
      dispatch(fetchAddPortabilityNumberList(payload))
        .then((res: any) => {
          setAddProtNumberList(res?.data?.indexedResults);
          setTotalData(res?.data?.totalRecords);
          setTableLoading(false);
        })
        .catch(() => {
          setAddProtNumberList([]);
          // if (messageAction === 'Add_portability_number') {
          //   setTotalData(0);
          // }
          setTableLoading(false);
        });
    },
    [dispatch]
  );

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (token && token !== "undefined") {
      console.log(messageAction, "messageAction");
      if (messageAction === "Start") {
        console.log("1");
        getList(savePayload);
      } else if (messageAction === "Inquire_number") {
        console.log("2");
        getInquireList(savePayload);
      } else if (messageAction === "Publish") {
        getPublishList(savePayload);
      } else if (messageAction === "Add_portability_number") {
        getAddPortNumberList(savePayload);
      }
    }
  }, [
    token,
    messageAction,
    savePayload,
    getList,
    getInquireList,
    getPublishList,
    getAddPortNumberList,
  ]);

  const runWebSocket = (ws: any) => {
    ws.onopen = function () {
      console.log("WebSocket connection established");
    };

    ws.onclose = function () {
      console.log("WebSocket connection closed");

      // Attempt to reconnect after a delay
      setTimeout(() => {
        reconnectWebSocket();
      }, 5000); // Retry after 5 seconds
    };

    ws.onmessage = function (event) {
      const eventData = JSON.parse(event.data);
      const token = localStorage.getItem("token");
      if (token === null) {
        navigate("/login");
      }

      const getNumber = eventData?.user_id || eventData?.user_id1;
      const getProvider_id = eventData?.provider_id;
      const getPublishMessage = eventData?.message;

      if (eventData?.request_id) {
        getList();
      } else if (getNumber) {
        getInquireList();
      } else if (getProvider_id) {
        getAddPortNumberList();
      } else if (getPublishMessage) {
        getPublishList();
      } else {
        ws.close();
      }
    };
  };
  const location = useLocation();

  let ws: WebSocket | null = null;

  const reconnectWebSocket = () => {
    if (!ws || ws.readyState === WebSocket.CLOSED) {
      console.log("Reconnecting WebSocket...");
      ws = new WebSocket(CONSTANT.WS_URL);
      runWebSocket(ws);
    }
  };

  // Extract the query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  const actionParam: string | null = queryParams.get("action");

  useEffect(() => {
    const ws = new WebSocket(CONSTANT.WS_URL);
    runWebSocket(ws);

    return () => {
      // Cleanup on component unmount
      if (ws) {
        ws.close();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (actionParam) {
      setMessageAction(actionParam);
    }
    if (actionParam === "Check" || actionParam === "Start") {
      console.log(":::");
      getList();
    }
  }, [actionParam, getList]);

  const getTitle: any = (title: string) => {
    if (title === "Start") {
      return "Start Portability";
    } else if (title === "Inquire_number") {
      return "Inquire Ownership Number";
    } else if (title === "Publish") {
      return "Publish";
    } else if (title === "Add_portability_number") {
      return "Add Portability Number";
    }
  };

  return (
    <>
      <ToolBar title={getTitle(actionParam)} />
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="large"
        onChange={() => {
          if (messageAction === "Check" || messageAction === "Start") {
            getList();
          } else if (messageAction === "Inquire_number") {
            getInquireList();
          } else if (messageAction === "Publish") {
            getPublishList();
          } else if (messageAction === "Add_portability_number") {
            getAddPortNumberList();
          }
          setSavePayload({});
        }}
        items={[
          {
            key: "1",
            label: "Make Request",
            children: (
              <SubmitForm
                getList={getList}
                getInquireList={getInquireList}
                getPublishList={getPublishList}
                messageAction={messageAction}
                setMessageAction={setMessageAction}
                getAddPortNumberList={getAddPortNumberList}
              />
            ),
          },
          {
            key: "2",
            label: "Search in List",
            children: (
              <SearchForm
                messageAction={messageAction}
                setMessageAction={setMessageAction}
                paginationData={paginationData}
                getList={getList}
                setSavePayload={setSavePayload}
                getInquireList={getInquireList}
                getAddPortNumberList={getAddPortNumberList}
                setPaginationData={setPaginationData}
              />
            ),
          },
        ]}
      />
      {messageAction === "Start" ? (
        <ListTable
          listData={listData}
          setListData={setListData}
          totalData={totalData}
          tableloading={tableloading}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          getList={getList}
          savePayload={savePayload}
        />
      ) : messageAction === "Inquire_number" ? (
        <InquireListTable
          listData={inquireListData}
          setListData={setInquireListData}
          totalData={totalData}
          tableloading={tableloading}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          getInquireList={getInquireList}
          savePayload={savePayload}
          getInquireReportList={getInquireReportList}
        />
      ) : messageAction === "Publish" ? (
        <PublishListTable
          listData={publishListData}
          setListData={setPublishListData}
          totalData={totalData}
          tableloading={tableloading}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          getList={getPublishList}
          savePayload={savePayload}
        />
      ) : (
        <AddPortabilityNumberListTable
          listData={addProtNumberListData}
          setListData={setAddProtNumberList}
          totalData={totalData}
          tableloading={tableloading}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          getAddPortNumberList={getAddPortNumberList}
          savePayload={savePayload}
        />
      )}
      {/* <Tabs
        defaultActiveKey={messageAction}
        activeKey={messageAction}
        type="card"
        size="large"
        onChange={(key) => {
          setMessageAction(key);
          setSavePayload({});
          setPaginationData({
            current: 1,
            page_size: 10,
          });
        }}
        onTabClick={(key) => setMessageAction(key)}
        items={[
          {
            key: "Start",
            label: "Portability List",
            children: (
             
            ),
          },
          {
            key: "Inquire_number",
            label: "Inquire Number List",
            children: (
              <InquireListTable
                listData={inquireListData}
                setListData={setInquireListData}
                totalData={totalData}
                tableloading={tableloading}
                setTableLoading={setTableLoading}
                paginationData={paginationData}
                setPaginationData={setPaginationData}
                getInquireList={getInquireList}
                savePayload={savePayload}
                getInquireReportList={getInquireReportList}
              />
            ),
          },
          {
            key: "Add_portability_number",
            label: "Add Portability Number",
            children: (
              <AddPortabilityNumberListTable
                listData={addProtNumberListData}
                setListData={setAddProtNumberList}
                totalData={totalData}
                tableloading={tableloading}
                setTableLoading={setTableLoading}
                paginationData={paginationData}
                setPaginationData={setPaginationData}
                getAddPortNumberList={getAddPortNumberList}
                savePayload={savePayload}
              />
            ),
          },
        ]}
      /> */}
    </>
  );
};

export default Monitor;
